import React, { useEffect, useState } from "react";
import Logo from "@/assets/logo.png";
import "./LoginForm.scss";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import Axios from "axios";
import { ApiUrls } from "@/utils/api/constant/api.constant";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import WelcomeLoader from "../WelcomeLoader/WelcomeLoader";
import { eventRoomStore } from "@/stores/event";
import { getRedirectTarget } from "@/utils/auth/redirect";

const LoginForm = () => {
  const history = useHistory();
  const location = useLocation();
  const [isloading, setisloading] = useState(false);
  const token = Cookies.get("accessToken") || Cookies.get("token");
  const redirectTarget = getRedirectTarget(
    (location.state as any) || undefined,
    location.search,
    "/visits"
  );

  if (token) {
    return <Redirect to={redirectTarget} />;
  }

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const username = event.target.username.value;
    const password = event.target.password.value;
    setisloading(true);
    Axios.post(ApiUrls.loginUrl, { username, password })
      .then(async (response) => {
        const accessToken = response.data.access || response.data.token;
        const refreshToken = response.data.refresh;


        if (accessToken) {
          Cookies.set("token", accessToken, {
            expires: 10,
            sameSite: "strict",
          });
          Cookies.set("accessToken", accessToken, {
            expires: 10,
            sameSite: "strict",
          });
          if (refreshToken) {
            Cookies.set("refreshToken", refreshToken, {
              expires: 10,
              sameSite: "strict",
            });
          }
          const currentUser = await eventRoomStore.getAuthorizedCurrentUser();
          if (!currentUser) {
            Cookies.remove("token");
            Cookies.remove("accessToken");
            Cookies.remove("refreshToken");
            setisloading(false);
            toast.error("Ce compte n'est pas autorisé à accéder à l'application.");
            return;
          }

          history.push(redirectTarget);
        } else {
          setisloading(false);
          toast.error("Le serveur d'authentification n'a pas renvoyé de jeton.");
        }
      })
      .catch((error) => {
        setisloading(false);
        console.log(error);
        const apiError =
          error?.response?.data?.detail ||
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.response?.data?.non_field_errors?.[0] ||
          "Impossible de se connecter.";
        toast.error(apiError);
      });
  };
  const date = new Date();
  const year = date.getFullYear();

  return (
    <>
      <div className="login">
        {isloading ? (
          <WelcomeLoader />
        ) : (
          <div className="login-container">
            <div>
              <img src={Logo} />
            </div>
            <p className="login-container-title"> BIENVENUE</p>
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="login-text">Enter your credentials</div>
              <label>Username</label>
              <input
                className="login-form-input"
                placeholder="username"
                name="username"
                type="text"
                id="user-text-field"
                autoComplete="username"
              />
              <label>Password</label>
              <input
                id="password-text-field"
                placeholder="password"
                className="login-form-input"
                type="password"
                autoComplete="current-password"
                name="password"
              />
              <button className="login-form-button" type="submit">
                LOGIN
              </button>
            </form>
            <footer>
              <div className="login-footer">
                &copy; COPYRIGHT - {year} -
                <a href="https://travelme-paris.com/">Travel-Me</a>
              </div>
              <div className="login-footer-term">
                By clicking Login , you agree to our
                <br></br>
                <div className="login-footer-term-link">
                  <a href="https://travelme-paris.com/en/terms-of-sales/">
                    Terms and Condition
                  </a>
                </div>
              </div>
            </footer>
          </div>
        )}
      </div>
    </>
  );
};

export default LoginForm;
